import './footer.css';

export default function Footer() {
    return (
        <div className='Footer'>
            <hr></hr>
            <p>This site is to be used for demonstration purposes only</p>
        </div>
    )
}